export default __webpack_public_path__ + "static/media/view.185c9efe.svg";